<script setup lang="ts">
import { computed } from 'vue';
import { isEmpty } from 'lodash';
import { useI18n } from 'vue-i18n';

import type { CheckTaskDocument } from '@nova/core';

const { documents } = defineProps<{
  documents?: CheckTaskDocument[];
}>();

const { t } = useI18n();

const hasDocuments = computed(() => !isEmpty(documents));
</script>

<template>
  <v-card variant="flat" border class="flex-fill">
    <v-card-text class="d-flex flex-column gap-2">
      <h4>{{ t('checkTaskDetails.attachments.heading') }}</h4>
      <!-- TODO(OD-3404): upload is owned by Helios at task creation; this view stays read-only -->
      <v-list
        v-if="hasDocuments"
        density="compact"
        class="py-0 bg-transparent"
        data-testid="task-attachments-list">
        <v-list-item
          v-for="doc in documents"
          :key="doc.id"
          :href="doc.url"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="task-attachments-row"
          class="px-0">
          <template #prepend>
            <v-icon icon="mdi-file-outline" size="small" />
          </template>
          <v-list-item-title class="typography-body-md">
            {{ doc.name }}
          </v-list-item-title>
          <template #append>
            <v-icon icon="mdi-download" size="small" class="text--color-text-secondary" />
          </template>
        </v-list-item>
      </v-list>
      <span v-else class="typography-body-md text--color-text-secondary">
        {{ t('checkTaskDetails.attachments.empty') }}
      </span>
    </v-card-text>
  </v-card>
</template>
